import {
  TbActivity, TbBarbell, TbChartBar, TbChartLine, TbClipboardList, TbDeviceTablet,
  TbAlertTriangle, TbHelpCircle, TbHome, TbLayoutDashboard, TbMessageCircle, TbReceipt, TbSettings,
  TbUserCheck, TbUserCircle, TbUsers,
} from 'react-icons/tb';

const EMPTY_STATE_ICONS = {
  Inicio: TbHome,
  Comunidad: TbMessageCircle,
  'Mi rutina': TbBarbell,
  Entrenar: TbActivity,
  Progreso: TbChartLine,
  'Mi cuota': TbReceipt,
  'Mi perfil': TbUserCircle,
  Resumen: TbLayoutDashboard,
  Socios: TbUsers,
  'Mis socios': TbUsers,
  'Detalle del socio': TbUserCheck,
  'Ficha del socio': TbUserCheck,
  Planes: TbClipboardList,
  Ejercicios: TbBarbell,
  Kioscos: TbDeviceTablet,
  Reportes: TbChartBar,
  Configuración: TbSettings,
};

/**
 * Page frame with a single h1 plus a loading / empty / error state. Task 6
 * uses it as the explicit temporary content of every route; later tasks keep
 * using it for their own loading and error moments.
 *
 * - `loading`: polite live region, so screen readers hear it once.
 * - `error`: alert with the (already safe) message and an optional action.
 * - `empty` (default): neutral message, optional action.
 */
const DEFAULT_MESSAGES = {
  loading: 'Cargando…',
  error: 'No se pudo cargar esta sección.',
  empty: 'Todavía no hay información para mostrar en esta sección.',
};

export function PageState({ title, status = 'empty', message, action, children }) {
  const text = message || DEFAULT_MESSAGES[status] || DEFAULT_MESSAGES.empty;
  const liveProps = status === 'loading'
    ? { role: 'status', 'aria-live': 'polite' }
    : status === 'error'
      ? { role: 'alert' }
      : {};
  const EmptyIcon = EMPTY_STATE_ICONS[title] || TbHelpCircle;

  const state = (
    <div className={`gym-state gym-state--${status}`} {...liveProps}>
      {status === 'loading' && (
        <div className="gym-state__skeleton" aria-hidden="true">
          <span className="gym-state__skeleton-card" />
          <span className="gym-state__skeleton-line" />
          <span className="gym-state__skeleton-card gym-state__skeleton-card--short" />
        </div>
      )}
      {status === 'empty' && <span className="gym-state__empty-icon" aria-hidden="true"><EmptyIcon /></span>}
      {status === 'error' && <span className="gym-state__error-icon" aria-hidden="true"><TbAlertTriangle /></span>}
      <p className="gym-state__text">{text}</p>
      {action && <div className="gym-state__action">{action}</div>}
    </div>
  );

  if (title == null) return state;

  return (
    <section className="gym-page" aria-labelledby="gym-page-title">
      <header className="gym-page__header">
        <h1 id="gym-page-title" className="gym-page__title">{title}</h1>
      </header>
      {state}
      {children}
    </section>
  );
}
